<ng-content></ng-content>
<ng-template [ngIf]="allowEmployee && employee?.id && !user?.employeeId">
    <span> {{ 'HEADER_TITLE.FOR' | translate }} </span>
    <span> {{ employee?.fullName }} </span>
</ng-template>

<ng-template [ngIf]="organization?.id">
    <span> {{ ((allowEmployee && employee?.id && !user?.employeeId) ? ('HEADER_TITLE.FROM' | translate) : ('HEADER_TITLE.FOR' | translate)) }}</span>
    <span> {{ organization?.name }} </span>
</ng-template>

